import { MenuSettings } from "./MenuSettings";
import { MainMenu } from "./MainMenu";
import { MENU_TYPE, useMenu } from "src/hooks/useMenu";

export const MENU_WIDTH = 228;
export const COLLAPSED_MENU_WIDTH = 52;

export function Menu({ orgId, loading }: { orgId?: string; loading: boolean }) {
  const { menu, setMenu } = useMenu(`${orgId}-active-menu`);
  return (
    <>
      {menu == "main" && (
        <MainMenu
          loading={loading}
          orgId={orgId}
          setMenu={(menu: MENU_TYPE) => setMenu(menu)}
        />
      )}
      {menu == "settings" && (
        <MenuSettings
          loading={loading}
          orgId={orgId}
          setMenu={(menu: MENU_TYPE) => setMenu(menu)}
        />
      )}
    </>
  );
}
